import { render, staticRenderFns } from "./UploadDocumentStatusFieldPopover.vue?vue&type=template&id=2d3771e0&"
import script from "./UploadDocumentStatusFieldPopover.vue?vue&type=script&lang=js&"
export * from "./UploadDocumentStatusFieldPopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports